import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { findUpcomingMatches } from '../network/FootbalService'
import { formatDate, formatTime } from '../utils/FormatDateTime'
import logoImage from '../images/logo192.png'
import { canAnalyzeMore } from '../utils/LimitHelper'
import { useAuth } from '../hooks/AuthContext'
import { Button } from 'react-bootstrap'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../services/Firebase'
import { useTranslation } from 'react-i18next'

export default function UpcomingMatches() {
    const { teamId } = useParams()
    const [matches, setMatches] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const navigate = useNavigate()
    const { authUser } = useAuth()
    const { t } = useTranslation()

    useEffect(() => {
        async function fetchMatches() {
            setLoading(true)
            try {
                const response = await findUpcomingMatches(teamId)
                const fixtures = response.data.response
                const matchArray = []
                fixtures.forEach(data => {
                    matchArray.push({
                        id: data.fixture.id,
                        timestamp: data.fixture.timestamp,
                        matchDate: data.fixture.date,
                        timezone: data.fixture.timezone,
                        leagueName: data.league.name,
                        leagueCountry: data.league.country,
                        teamHomeName: data.teams.home.name,
                        teamAwayName: data.teams.away.name,
                        teamHomeId: data.teams.home.id,
                        teamAwayId: data.teams.away.id
                    })
                });
                setMatches(matchArray)
                console.log(matchArray)
                setLoading(false)
            } catch (error) {
                console.log(error)
                logEvent(analytics, 'match_not_found')
                setError("Failed to load matches");
            } finally {
                setLoading(false)
            }
        }
        fetchMatches()
    }, [teamId])

    function onSelectMatch(match, index) {
        if (!canAnalyzeMore(!!authUser)) {
            let alertMessage = t('dailyLimitReached')
            if (authUser !== null) {
                alertMessage = t('todayLimitUsed')
                logEvent(analytics, "match_selected", {
                    list_position: index,
                    is_logged_in: !!authUser
                })
            } else {
                // todo poslati analytic event za limit neulogovanog
            }
            alert(alertMessage);
            return;
        }
        navigate('/result', { state: match })
    }

    const goToSearchPage = () => {
        navigate('/')
    }

    const goToLoginPage = () => {
        navigate('/login')
    }

    const handleProfileClick = () => {
        navigate('/profile')
    }

    return (
        <div className='search-page'>
            <div className="header-container">
                <div onClick={() => goToSearchPage()} className='header-left'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right'>
                    {!authUser && <Button onClick={() => goToLoginPage()} className='button-logout'><i class="bi bi-box-arrow-in-right"></i>{t('loginMember')}</Button>}
                    {authUser && <Button onClick={() => handleProfileClick()} className='button-profile'><i class="bi bi-person-circle"></i>{t('memberProfile')}</Button>}
                </div>
            </div>
            <div className="match-screen">
                <div className="overlay">
                    {loading && <p className="loading">{t('loadingUpcomingMatches')}</p>}
                    {error && <p className="error">{error}</p>}
                    {!loading && matches.length === 0 && (
                        <p className="no-matches">{t('noUpcomingMatches')}</p>
                    )}
                    {!loading && matches.length > 0 && (
                        <>
                            <h1 className='upcoming-matches-title'>{t('selectMatch')}</h1>
                            <div className="match-grid">
                                {matches.map((match, index) => (
                                    <div className="match-card" onClick={() => onSelectMatch(match, index)} key={match.id}>
                                        <div className="match-info">
                                            <div className="match-middle">
                                                <div className="match-score">
                                                    {formatTime(match.matchDate)}h
                                                </div>
                                            </div>
                                            <div className="club-names">
                                                <span>{match.teamHomeName}</span>
                                                <span>{match.teamAwayName}</span>
                                            </div>
                                        </div>

                                        <div>
                                            <div className='match-date-time'>{formatDate(match.matchDate)}</div>
                                            <div className="league-name">{match.leagueName}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
